var React = require('react');

function TestimonialQuotemarkMobile (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.4037.00014l.6506 1.80662C11.4351 13.5771 8.8618 26.6887 5.33436 41.1416H-.00017c.8674-6.2958 1.73481-13.4127 2.60221-21.3509C3.44053 11.9074 4.04771 5.31048 4.42359.00014h7.98011zm16.0036 0l.5204 1.80662c-.6361 4.92712-1.6625 11.05864-3.0792 18.39454-1.4168 7.336-2.9348 14.3161-4.5539 20.9403h-5.3345c1.9082-13.9054 3.3973-27.6192 4.4671-41.14146h7.9801z","fill":"#6C727B"}));
}

TestimonialQuotemarkMobile.defaultProps = {"fill":"none","viewBox":"0 0 29 41"};

module.exports = TestimonialQuotemarkMobile;

TestimonialQuotemarkMobile.default = TestimonialQuotemarkMobile;
